import { BarChart3, BookOpenCheck, Camera, ClipboardList, FilePenLine, FileScan, GraduationCap, Home, Layers3, School, Settings, Target, UploadCloud, Users } from 'lucide-react';
import type { RadarRole } from '../types/app';

export type NavItem = {
  id: string;
  label: string;
  icon: typeof Home;
  roles?: RadarRole[];
};

export const navItems: NavItem[] = [
  { id:'home', label:'Início', icon:Home },
  { id:'assessments', label:'Simulados', icon:ClipboardList },
  { id:'launches', label:'Lançamentos', icon:UploadCloud },
  { id:'sheets', label:'Folhas / QR Code', icon:FileScan },
  { id:'omr', label:'Câmera / OMR', icon:Camera },
  { id:'writing', label:'Produção Escrita', icon:FilePenLine },
  { id:'students', label:'Estudantes', icon:Users },
  { id:'classes', label:'Turmas', icon:School },
  { id:'matrix', label:'Matrizes', icon:BookOpenCheck },
  { id:'reports', label:'Relatórios', icon:BarChart3 },
  { id:'analysis', label:'Análises', icon:Layers3 },
  { id:'interventions', label:'Intervenções', icon:Target },
  { id:'settings', label:'Configurações', icon:Settings, roles:['admin'] },
  { id:'education', label:'Gestão pedagógica', icon:GraduationCap, roles:['admin','coordinator_literacy','coordinator_fundamental'] },
];

export function navigationForRole(role: RadarRole) {
  return navItems.filter(item => !item.roles || item.roles.includes(role));
}
